/** @typedef {import('../lib/types.js').NoteContentBlock} NoteContentBlock */
import { NOTES_DEMO_TAB_CONTENT } from './notesDemoTabContent'

/** @param {string} noteId @param {boolean} isMeeting */
export function buildDefaultTabContent(noteId, isMeeting) {
  if (NOTES_DEMO_TAB_CONTENT[noteId]) return NOTES_DEMO_TAB_CONTENT[noteId]

  const empty = [{ type: 'paragraph', text: '' }]
  if (isMeeting) {
    return {
      meetingDetail: empty,
      summary: empty,
      transcript: empty,
      myNotes: empty,
      chat: empty,
    }
  }
  return { notes: empty, chat: empty }
}
